<template lang="pug">
.container.col-centered
  .row
    h2.main_title Private MIB
    .col-md-12.function_bar(style="display:flex; justify-content: space-between;")
      .form-group
        label.control_label
          | Search:
        tooltip(effect="scale" placement="bottom" content="Search by version, custom, release notes, bug fix, min firmware or MD5")
          input.form-control(v-model="temporarySearchQuery" @keydown.enter="applySearchQuery" placeholder="Search..." style="display: inline-block; width: auto; vertical-align: middle;")
      .form-group(v-bind:class="{'col-md-4': $route.name === 'switch', 'col-md-2': $route.name === 'smart-controller'}")
        label.control_label
          | Category:
        v-select(v-bind:value.sync='logFilter.category.value' v-bind:options='logFilter.category.opts')
      //- .form-group(style="margin-left: 10px;" v-bind:class="{'col-md-4': $route.name === 'switch', 'col-md-2': $route.name === 'smart-controller'}")
        //- label.control_label
          //- | Custom:
        //- v-select(v-bind:value.sync='logFilter.custom.value' v-bind:options='logFilter.custom.opts')
      .form-group(v-if="user.role === 'admin' || isIntrising" style="margin-left: 10px;" v-bind:class="{'col-md-4': $route.name === 'switch', 'col-md-2': $route.name === 'smart-controller'}")
        label.control_label
          | Status:
        v-select(v-bind:value.sync='logFilter.status.value' v-bind:options='logFilter.status.opts')
    spinner(v-ref:spinner size="md" show="true" v-bind:text="spinnerTxt")
    div(v-if="pageLoaded")
      pagination(
        v-bind:sort-method.sync="sortMethod"
        v-bind:sort-method-opts="sortMethodOpts"
        v-bind:count-of-page.sync="countOfPage"
        v-bind:curr-page.sync="currPage"
        v-bind:count-of-pagination="countOfPagination"
        v-bind:curr-pagination-sec.sync='currPaginationSec'
        v-bind:target-ary.sync='searchFilteredTotalLog'
        v-bind:expand-all.sync='expandAll'
        v-bind:show-toggle-expansion-btn='true'
      )
      .col-md-12.main_table(v-if="searchFilteredTotalLog.length > 0")
        table.table.table-bordered.table-hover.log_table
          tr(v-for="($index, mib) in searchFilteredTotalLog  | limitBy countOfPage pageStart")
            td {{$index + 1 + pageStart}}
            td.single_log
              .media
                .media-left
                  .media-object.device_icon(v-bind:class="mib.category")
                    img(v-bind:src="getIconSrc(mib.category)")
                .media-body
                  .media-top
                    span.media-top__info
                      .version-row
                        span.version.text-uppercase {{ mib.version }}
                        //- span.model.type_tag.base_black.base_grey_bg(style="margin-left: 10px;") {{getCustomForUI(mib.custom)}}
                        span.model.type_tag.base_black.base_white_bg(v-if="['router', 'routerx'].includes(mib.category) && mib.firmwareLayer != null") Layer {{ mib.firmwareLayer }}
                      span.time
                        span.glyphicon.glyphicon-time
                        span(v-if="sortMethod.name !== 'updatedAt'") Released at {{ mib.createdAt | fromNow }}
                        span(v-if="sortMethod.name === 'updatedAt'") Updated at {{ mib.updatedAt | fromNow }}
                    .action_buttons
                      .btn-group
                        button.btn.btn-sm.btn-default(@click="handleShowModal('update', mib['.key'], $index)" v-if="['admin', 'vendor', 'salesperson'].includes(user.role)")
                          span.glyphicon.glyphicon-pencil
                        button.btn.btn-sm.btn-default(@click="handleShowDeleteConfirm(mib['.key'], mib.category)" v-if="user.role === 'admin'")
                          span.glyphicon.glyphicon-trash
                        button.btn.btn-sm.btn-default(@click="handleShowDownloadModal(mib)" v-if="!mib.url || mib.url === ''")
                          span.glyphicon.glyphicon-cloud-download
                          span  Download
                        button.btn.btn-sm.btn-primary(@click="handleDirectDownload(mib.url)" v-if="mib.url && mib.url !== ''")
                          span.glyphicon.glyphicon-download-alt
                          span  Direct Download
                  .media-middle
                    line-table(title='MD5:' v-bind:content='mib.md5' v-if='mib.md5 != null && mib.md5.length !== 0')
                    line-table(title='Minimum Firmware:' v-bind:content='mib.minimaFw')
                    line-table(
                      title='Download URL:'
                      v-bind:content='mib.url'
                      v-if='mib.url && mib.url.length !== 0'
                      v-bind:is-link="true"
                    )
                    line-table(
                      title='Release Notes'
                      v-bind:is-md="true"
                      v-bind:default-collapse="!(searchQuery.trim() !== '' && mib.releaseNote && mib.releaseNote.toLowerCase().includes(searchQuery.toLowerCase()))"
                      v-bind:content='highlightMatches(mib.releaseNote, searchQuery, false)'
                      v-if='mib.releaseNote && mib.releaseNote.length !== 0'
                      v-bind:expand-all='expandAll'
                    )
                    line-table(
                      title='Bug Fixes'
                      v-bind:is-md="true"
                      v-bind:default-collapse="!(searchQuery.trim() !== '' && mib.bugFixed && mib.bugFixed.toLowerCase().includes(searchQuery.toLowerCase()))"
                      v-bind:content='highlightMatches(mib.bugFixed, searchQuery, false)'
                      v-if='mib.bugFixed && mib.bugFixed.length !== 0'
                      v-bind:expand-all='expandAll'
                    )
                .media-right.badge_group
                  .customized__badge(v-bind:class="mib.status === 'release' ? 'release' : 'develop'")
                    span {{mib.status === 'release' ? 'release' : 'develop' }}
      .col-md-12(v-if="searchFilteredTotalLog.length <= 0")
        h3.text-center.text-muted No Data
  modal(
    v-bind:title.sync='modalTitle'
    v-bind:ok-text.sync='okText'
    backdrop='false'
    v-bind:callback='modalCb'
    v-bind:show.sync='showModal')
    .modal-body.upload_modal(slot='modal-body')
      .col-md-12.clearfix.col-centered
        .form-group.col-md-12.clearfix(v-if='isUpdate')
          .col-md-3.form_label.clearfix
            label.control_label
              | Last update:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='newPMIB.updatedAt' readonly)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Release Date:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='newPMIB.createdAt' readonly v-if="user.role !== 'admin'")
            datepicker(v-bind:value.sync="newPMIB.createdAt" v-bind:format="'yyyy/M/dd'" placeholder="Default is current time." v-else)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Version:
          .col-md-9.no_pad.clearfix
            input.form-control(readonly v-bind:value="newPMIB.version")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Status:
          .col-md-9.no_pad.clearfix
            v-select(
              v-if="user.role === 'admin'"
              v-bind:value.sync="newPMIB.status"
              v-bind:options="[{label: 'Release', val: 'release'}, {label: 'Develop', val: 'develop'}]"
              options-value="val"
              close-on-select
            )
            input.form-control(v-else readonly v-bind:value="newPMIB.status[0].toUpperCase() + newPMIB.status.substr(1)")
        .form-group.col-md-12.clearfix.larger_form_group
          .col-md-3.form_label.clearfix
            label.control_label
              | Release Notes:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='newPMIB.releaseNote' placeholder='### V5.01.1007-spec_2506_a22\n\n- Date: 2025-08-05 01:35:04\n- Description:\n  - Features:\n    - [25-XX] New feature description\n  - Bug fixes:\n    - Device reboots unexpectedly under high CPU load (#999)\n  - OID Changes:\n    - Add: newFeatureTable ${enterpriseOID}.x.x.x\n    - Update: existingOidName ${enterpriseOID}.y.y.y' v-bind:disabled="user.role === 'client'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | MD5:
          .col-md-9.no_pad.clearfix
            input.form-control(v-model='newPMIB.md5' placeholder='a1b2c3d4e5f6789012345678901234ab' v-bind:disabled="user.role === 'client'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Min Firmware:
          .col-md-9.no_pad.clearfix
            input.form-control(v-model='newPMIB.minimaFw' placeholder='OS4 L3 V6.01.0045' v-bind:disabled="user.role === 'client'")
        .form-group.col-md-12.clearfix(v-if="['router', 'routerx'].includes(newPMIB.category)")
          .col-md-3.form_label.clearfix
            label.control_label
              | Firmware Layer:
          .col-md-9.no_pad.clearfix
            v-select(
              v-if="user.role !== 'client'"
              v-bind:value.sync="newPMIB.firmwareLayer"
              v-bind:options="[{label: 'Layer 2', val: 2}, {label: 'Layer 3', val: 3}]"
              options-value="val"
              close-on-select
            )
            input.form-control(v-else readonly v-bind:value="newPMIB.firmwareLayer ? 'Layer ' + newPMIB.firmwareLayer : 'Not specified'")
        .form-group.col-md-12.clearfix.larger_form_group
          .col-md-3.form_label.clearfix
            label.control_label
              | Bug Fixes:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='newPMIB.bugFixed' placeholder='## Critical Bug Fixes\n\n- **OSPF neighbor adjacency** takes over 5 minutes to establish (#2501)\n- **VRRP master election** fails when priority values are identical (#2502)\n- **SNMP agent crashes** during heavy load scenarios with 1000+ OID requests (#2503)\n- **Memory leak** in BGP route processing after 72 hours uptime (#2504)\n\n### Impact\nThese fixes address production stability concerns and improve overall system reliability.' v-bind:disabled="user.role === 'client'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Download URL:
          .col-md-9.no_pad.clearfix
            input.form-control(v-model='newPMIB.url' placeholder='https://drive.google.com/open?id=1ZbADatyaBt25xSx56sO3CPj3v-7awxrP' v-bind:disabled="user.role === 'client'")
  modal(
    title='Select Private MIB'
    backdrop='false'
    v-bind:show.sync='showDownloadModal'
  )
    .modal-body.upload_modal(slot='modal-body')
      .col-md-12.clearfix.col-centered
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Model:
          .col-md-9.no_pad.clearfix
            v-select(
              v-if="getModelOptions(downloadTarget.candidates).length > 0"
              v-bind:value.sync="downloadTarget.filter.model"
              v-bind:options="getModelOptions(downloadTarget.candidates)"
              options-value="val"
              search justified required close-on-select
            )
            input.form-control(readonly value="No model matched." v-else)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Layer:
          .col-md-9.no_pad.clearfix
            v-select(options-value="val" v-bind:value.sync="downloadTarget.filter.layerMode" v-bind:options="layerModeOpts")
    .modal-footer.upload_modal(slot='modal-footer')
      button.btn.btn-default(@click="cancelDownloadModal") Cancel
      button.btn.btn-primary(@click="downalodMib" v-bind:disabled="downloadTarget.filter.layerMode == null || downloadTarget.filter.model == null || mibUrlLoadingState === 1") {{ mibUrlLoadingState === 0 ? 'Download' : mibUrlLoadingState === 1 ? 'Loading...' : mibUrlLoadingState === 2 ? 'Downloading' : 'Error'}}
  modal(
    title='Confirm'
    v-bind:show.sync='showDeleteConfirm')
    .l-body(slot='modal-body')
      h4.text-center Are you sure to delete?
    .modal-footer(slot='modal-footer')
      button.btn.btn-default(@click='showDeleteConfirm = false')
        | No
      button.btn.btn-danger(@click='applyDelete')
        | Yes
  alert(v-bind:show.sync="showAlert" placement="top" duration="5000" type="danger" width="400px" dismissable)
    span(class="icon-info-circled alert-icon-float-left")
    h4 The following fields are required:
      ul
        li(v-if="!newPMIB.status || !newPMIB.status.trim()") Status
        li(v-if="!newPMIB.url") Download URL
        li(v-if="!newPMIB.md5") MD5
        li(v-if="newPMIB.md5 && newPMIB.md5.length !== 32") MD5 must be 32 characters
</template>
<script>
import moment from 'moment'
import { alert, datepicker, dropdown, modal, select, spinner, tooltip } from 'vue-strap'
import pagination from '../common/Pagination.vue'
import lineTable from '../common/LinedTable'
import { getFireBase, getModelForUI, getCustomForUI, naturalSorting, getIconSrc, getDb, filterOptions, snmpOidDocOpts } from '../../index.js'
import searchMixin from '../../mixins/searchMixin.js'
import permissionsMixin from '../../mixins/permissionsMixin.js'
import _ from 'lodash'

// URL validation helper function (moved from Router.js)
function isValidUrl(string) {
  try {
    const url = new URL(string)
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch (_) {
    return false
  }
}

const fb = getFireBase()
export default {
  mixins: [searchMixin, permissionsMixin],
  components: {
    alert,
    datepicker,
    dropdown,
    modal,
    pagination,
    'v-select': select,
    'line-table': lineTable,
    spinner,
    tooltip
  },
  vuex: {
    getters: {
      user: state => state.user
    }
  },
  data () {
    return {
      pageLoaded: false,
      countOfPage: 50,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1,
      sortMethod: {
        name: 'version',
        asc: false
      },
      sortMethodOpts: [
        {
          label: 'Sort by Release Date',
          value: 'createdAt'
        },
        {
          label: 'Sort by Update Time',
          value: 'updatedAt'
        },
        {
          label: 'Sort by Version',
          value: 'version'
        }
      ],
      newPMIB: {
        model: null,
        category: '',
        custom: '',
        url: '',
        bugFixed: '',
        createdAt: '',
        updatedAt: '',
        version: '',
        status: ' ',
        releaseNote: '',
        md5: '',
        minimaFw: '',
        firmwareLayer: null
      },
      option: {
        model: {
          opts: []
        },
        status: {
          opts: filterOptions.status.firmware
        }
      },
      showModal: false,
      showAlert: false,
      showDownloadModal: false,
      modalTitle: '',
      okText: '',
      modalCb: function () {},
      editingKey: '',
      editingCategory: '',
      showDeleteConfirm: false,
      logFilter: {
        family: {
          opts: [
            {label: 'Any', value: 'any'}
          ],
          value: 'any'
        },
        custom: {
          opts: filterOptions.custom,
          value: 'any'
        },
        date: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: '1 month', value: 'month'}
          ],
          value: 'any'
        },
        category: {
          opts: filterOptions.category, // dynamic generated by $route.name
          value: 'any'
        },
        status: {
          opts: filterOptions.status.firmware,
          value: 'any'
        }
      },
      isUpdate: false,
      snmpOidDocOpts,
      searchModelTxt: '',
      downloadTarget: {
        candidates: {},
        filter: {
          layerMode: null,
          model: null
        }
      },
      mibUrlLoadingState: 0,
      spinnerTxt: 'Loading...',
      pmib: [],
      product: [],
      searchQuery: '',
      expandAll: false,
      temporarySearchQuery: ''
    }
  },
  ready () {
    this.$refs.spinner.show()
    // gen logFilter
    let optAny = {label: 'Any', value: 'any'}
    // Start from full list, then remove restricted categories based on user
    this.logFilter.category.opts = _.cloneDeep(filterOptions.category)

    // Hide AutoPVT for non-intrising users
    if (!this.isIntrising) {
      this.logFilter.category.opts = _.filter(this.logFilter.category.opts, (obj) => obj.value !== 'autopvt')
    }
    this.logFilter.category.opts.unshift(optAny)
    this.logFilter.custom.opts = _.cloneDeep(filterOptions.custom)
    this.logFilter.custom.opts.unshift(optAny)
    this.logFilter.status.opts = _.cloneDeep(filterOptions.status.firmware)
    this.logFilter.status.opts.unshift(optAny)

    /*
      Handle URL query parameters (like Firmware.vue)
    */
    this.logFilter.category.value = this.$route.query.category || 'any'
    this.logFilter.custom.value = this.$route.query.custom || 'any'
    this.logFilter.status.value = this.$route.query.status || 'any'
    this.temporarySearchQuery = this.$route.query.search || ''
    this.searchQuery = this.$route.query.search || ''


    this.getData('intrising')
  },
  computed: {
    layerModeOpts () {
      const selectedModel = this.downloadTarget.filter.model
      if (selectedModel == null) {
        return [
          { label: 2, val: 2 },
          { label: 3, val: 3 }
        ]
      } else {
        const {l2, l3} = _.find(this.downloadTarget.candidates.models, {model: selectedModel})
        const result = []
        if (l2) result.push({ label: 2, val: 2 })
        if (l3) result.push({ label: 3, val: 3 })
        return result
      }
    },
    categorizedFamily () {
      // filterOptions.category
      const cf = {}
      for (let i in this.totalLog) {
        const cat = this.totalLog[i].category
        if (cf[cat] == null) cf[cat] = []
        cf[cat].push(this.totalLog[i].family)
        cf[cat] = _.uniq(cf[cat])
      }
      // console.log(cf)
      return cf
    },
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    },
    searchModelObj () {
      if (/^[a-zA-Z0-9-]+$/.test(this.searchModelTxt)) {
        return {
          isValid: true,
          value: this.searchModelTxt
        }
      } else if (this.searchModelTxt === '') {
        return {
          isValid: true,
          value: ''
        }
      } else {
        return {
          isValid: false,
          value: ''
        }
      }
    },
    totalLog () {
      let pmib = this.pmib
      // replace mib status to product status
      let prod = null

      pmib = pmib
        .map(x => {
          // Ensure required fields exist with defaults
          x.bugFixed = x.bugFixed == null ? '' : x.bugFixed
          x.category = x.category || 'router'  // Default to router instead of unknown
          x.custom = x.custom || 'lantech_lantech'  // Default to lantech_lantech instead of unknown
          // V2 structure doesn't need models mapping like V1
          return x
        }).filter(p => {
          // Filter by category
          return this.logFilter.category.value !== 'any'
            ? p.category === this.logFilter.category.value
            : typeof (_.find(this.logFilter.category.opts, {value: p.category})) !== 'undefined'
        })

      const { name, asc: isAsc } = this.sortMethod
      if (name === 'version') {
        pmib = naturalSorting(pmib, 'version', isAsc ? 'asc' : 'desc')
      } else {
        pmib = _.orderBy(pmib, [name], [isAsc ? 'asc' : 'desc'])
      }
      return pmib
    },
    statusFilteredTotalLog () {
      const canSeeDevelop = this.user.role === 'admin' || this.isIntrising
      if (canSeeDevelop) {
        return this.totalLog.filter(p => {
          return this.logFilter.status.value !== 'any' ? p.status === this.logFilter.status.value : typeof (_.find(this.logFilter.status.opts, {value: p.status})) !== 'undefined'
        })
      } else {
        return this.totalLog.filter(p => p.status !== 'develop')
      }
    },
         searchFilteredTotalLog () {
       if (!this.searchQuery) {
         return this.statusFilteredTotalLog
       }
       return this.statusFilteredTotalLog.filter(mib => {
        const lowerCaseSearchQuery = this.searchQuery.toLowerCase()
        return (
          mib.custom.toLowerCase().includes(lowerCaseSearchQuery) ||
          mib.version.toLowerCase().includes(lowerCaseSearchQuery) ||
          (mib.releaseNote && mib.releaseNote.toLowerCase().includes(lowerCaseSearchQuery)) ||
          (mib.bugFixed && mib.bugFixed.toLowerCase().includes(lowerCaseSearchQuery)) ||
          (mib.minimaFw && mib.minimaFw.toLowerCase().includes(lowerCaseSearchQuery)) ||
          (mib.md5 && mib.md5.toLowerCase().includes(lowerCaseSearchQuery))
        )
      })
    }
  },
  watch: {
    logFilter: {
      deep: true,
      handler: function (nv) {
        this.currPage = 1
        this.currPaginationSec = 1
        this.updateQueryParams()
      }
    },
    searchQuery: function (newQuery) {
      this.updateQueryParams()
    }
  },
  methods: {
    getLabel (type, val, isProd) {
      let target
      if (type === 'status') target = filterOptions[type][isProd ? 'product' : 'firmware']
      else target = filterOptions[type]
      return _.find(target, {value: val}) == null ? 'None' : _.find(target, {value: val}).label
    },
    checkStringEqual (src, target) {
      if (typeof src === 'string' && typeof target === 'string') {
        return src.toUpperCase() === target.toUpperCase()
      } else {
        return false
      }
    },
    alert (type, title, content) {
      this.$dispatch('alert', {
        type,
        title,
        content
      })
    },
    updateQueryParams() {
      const query = {
        category: this.logFilter.category.value,
        custom: this.logFilter.custom.value,
        status: this.logFilter.status.value
      }
      if (this.searchQuery) {
        query.search = this.searchQuery
      }
      this.$router.replace({ query })
    },
    copyToClipboard(version) {
      const url = `${window.location.origin}/privateMIB?category=any&custom=any&search=${version}&status=any`
      navigator.clipboard.writeText(url).then(() => {
        this.alert('success', 'URL Copied', 'The URL has been copied to your clipboard.')
      }).catch(err => {
        console.error('Failed to copy URL: ', err)
        this.alert('error', 'Copy Failed', 'Failed to copy URL to clipboard.')
      })
    },
    handleDownload (url, e) {
      window.open(url)
    },
    handleDirectDownload (url) {
      if (url && url.trim() !== '') {
        window.open(url, '_blank')
      }
    },
    getModelForUI,
    getCustomForUI,
    getIconSrc,
    handleShowModal (which, key, index) {
      // console.log('key', key)
      // console.log('index', index + this.pageStart)

      this.editingKey = key
      if (which === 'upload') {
        this.modalTitle = 'Add Private MIB'
        this.isUpdate = false
        this.okText = 'Add'
        let category, /* custom, */ model

        this.option.model.opts = []
        for (let p of this.product) {
          if (this.pmib[p.board] == null) {
            this.option.model.opts.push({label: p.board, value: p.board})
            if (this.option.model.opts.length <= 1) {
              model = this.option.model.opts[0].value
            }
            if (p['.key'] === model) {
              category = p.category
              // custom = p.custom
            }
          }
        }
        this.option.model.opts = _.uniqBy(this.option.model.opts, 'value')

        this.newPMIB = {
          model,
          category,
          // custom,
          url: '',
          bugFixed: '',
          releaseNote: '',
          md5: '',
          createdAt: moment(new Date()).format('YYYY/MM/DD HH:mm:ss')
        }
        this.modalCb = this.applyUpload
      } else if (which === 'update') {
        this.modalTitle = 'Edit Private MIB'
        this.isUpdate = true
        this.okText = 'Update'
        this.modalCb = this.applyUpdate

        let { updatedAt = '', createdAt = '', bugFixed = '', releaseNote = '', md5 = '', minimaFw = '', firmwareLayer = null, status, version, category = '', url = '' } = this.searchFilteredTotalLog[index + this.pageStart]
        this.newPMIB.updatedAt = moment(updatedAt).format('YYYY/MM/DD HH:mm:ss')
        this.newPMIB.createdAt = moment(createdAt).format('YYYY/MM/DD HH:mm:ss')
        this.newPMIB.bugFixed = bugFixed
        this.newPMIB.releaseNote = releaseNote
        this.newPMIB.md5 = md5
        this.newPMIB.minimaFw = minimaFw
        this.newPMIB.firmwareLayer = firmwareLayer
        this.newPMIB.category = category
        this.newPMIB.status = status
        this.newPMIB.version = version
        this.newPMIB.url = url
        this.newPMIB.key = this.searchFilteredTotalLog[index + this.pageStart]['.key']
        this.showModal = true
      }
    },
    handleShowDeleteConfirm (key, category) {
      this.editingKey = key
      this.editingCategory = category
      this.showDeleteConfirm = true
    },
    handleShowDownloadModal (target) {
      this.showDownloadModal = true
      this.downloadTarget.candidates = target
      this.downloadTarget.filter.model = this.getModelOptions(target)[0].val
    },
    getModelOptions (target) {
      const models = target.models || []
      const result = models.filter(({ model }) => {
        if (this.user.role === 'admin') return true
        else {
          const list = this.product.filter(z => model === z['.key'])
          return list.length && list[0].status === 'release'
        }
      }).map(({ model }) => ({
        label: model,
        val: model
      }))
      return naturalSorting(result, 'label', 'asc')
    },
    async downalodMib () {
      const {
        candidates: { version, custom, category },
        filter: { layerMode, model }
      } = this.downloadTarget
      const key = `${category}_${custom}_${version.replace(/\./g, '!')}_${model}_l${layerMode}`
      this.mibUrlLoadingState = 1
      const url = await fb.database().ref('privateMib/v2/download').child(key).once('value').then((sn) => sn.val())
      this.mibUrlLoadingState = 2
      window.open(url)
      this.showDownloadModal = false
      this.mibUrlLoadingState = 0
    },
    cancelDownloadModal () {
      this.showDownloadModal = false
      this.downloadTarget = {
        candidates: {},
        filter: {
          layerMode: 2,
          model: null
        }
      }
    },
    handleShowDeleteConfirm (key, category) {
      this.editingKey = key
      this.editingCategory = category
      this.showDeleteConfirm = true
    },
    applyUpload () {
      const { status, url, md5 } = this.newPMIB
      if (!status || !status.trim() || !url || !md5 || md5.length !== 32) {
        this.showAlert = true
        return
      }
      let key = 'pmib'
      const {
        model,
        category,
        // custom,
        bugFixed,
        createdAt,
        releaseNote
      } = this.newPMIB
      let toPush = {
        category,
        // custom,
        status,
        url,
        bugFixed,
        createdAt: (new Date(createdAt)).getTime(),
        updatedAt: (new Date(createdAt)).getTime(),
        releaseNote,
        md5
      }
      this.$firebaseRefs[key].child(model).set(toPush)
      this.showModal = false
    },
    applyUpdate () {
      const {
        key,
        status,
        releaseNote,
        md5,
        minimaFw,
        firmwareLayer,
        bugFixed,
        url
      } = this.newPMIB

      if (!status || !status.trim()) {
        this.showAlert = true
        return
      }

      // Validate URL if provided
      if (url && url.trim() !== '' && !isValidUrl(url.trim())) {
        this.$dispatch('alert', {
          type: 'error',
          title: 'Invalid URL',
          content: 'Please enter a valid HTTP or HTTPS URL.'
        })
        return
      }

      let update = {
        status,
        releaseNote,
        md5,
        minimaFw,
        firmwareLayer,
        bugFixed,
        url: url ? url.trim() : '',
        updatedAt: fb.database.ServerValue.TIMESTAMP
      }
      getDb().ref('privateMib/v2/entry').child(key).update(update)
      this.showModal = false
    },
    async applyDelete () {
      this.showDeleteConfirm = false
      const key = this.editingKey

      try {
        this.spinnerTxt = 'Deleting...'

        // For V2, we simply delete the entry from the privateMib/v2/entry node
        // V2 doesn't have the complex models structure or download links like V1
        await getDb().ref('privateMib/v2/entry').child(key).remove()

        this.alert('success', 'Deleted', 'Private MIB entry has been deleted successfully.')
      } catch (error) {
        console.error('Delete error:', error)
        this.alert('error', 'Delete Failed', 'Failed to delete the Private MIB entry.')
      } finally {
        this.spinnerTxt = 'Loading...'
      }
    },
    createTestData () { /** for creating Private MIB V2 test data */
      const defaults = {
        status: ['develop', 'release']
      }
      const data = {
        bugFixed: 'Fixed some bugs in V2',
        category: filterOptions.category[_.random(0, 3)].value,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        custom: filterOptions.custom[_.random(0, 7)].value,
        releaseNote: 'Test release note for V2',
        status: defaults.status[_.random(0, 1)],
        url: 'https://drive.google.com/uc?export=download&id=0B7_m7TkQhzE1bmZaRWNXOUc4UWM',
        version: 'V' + _.random(6, 9) + '.01.' + _.random(1000, 9999),
        md5: 'a1b2c3d4e5f6789012345678901234ab',
        minimaFw: 'OS4 L3 V6.01.' + _.random(100, 999),
        firmwareLayer: _.random(2, 3),
        customVersion: '',
        categoryCustomVersion: ''
      }
      // Set proper unique keys for V2
      data.customVersion = `${data.custom}_${data.version}`
      data.categoryCustomVersion = `${data.category}_${data.custom}_${data.version}`

      getDb().ref('privateMib/v2/entry').push(data)
    },
    getData (custom) {
      const query = {
        mibEntry: getDb().ref('privateMib/v2/entry').orderByChild('custom').startAt(custom).endAt(custom),
        product: getDb().ref('product').orderByChild(`custom/${custom}`).equalTo(custom)
      }
      query.mibEntry.on(
        'value',
        (sn) => {
          this.$refs.spinner.hide()
          this.pageLoaded = true
                    this.pmib = _.transform(sn.val(), (result, value, key) => {
            // Allow all data for intrising users (no status filtering)
            if (this.user.role !== 'admin' && !this.isIntrising && value.status !== 'release') return

            // Ensure all required fields have default values for backward compatibility
            const mibEntry = {
              '.key': key,
              bugFixed: value.bugFixed || '',
              category: value.category || 'unknown',
              createdAt: value.createdAt || Date.now(),
              custom: value.custom || '',
              customVersion: value.customVersion || '',
              categoryCustomVersion: value.categoryCustomVersion || `${value.category}_${value.custom}_${value.version}`,
              firmwareLayer: value.firmwareLayer || null,
              md5: value.md5 || '',
              minimaFw: value.minimaFw || '',
              models: value.models || [],
              releaseNote: value.releaseNote || '',
              status: value.status || 'develop',
              updatedAt: value.updatedAt || value.createdAt || Date.now(),
              version: value.version || 'Unknown',
              url: value.url || ''
            }

            result.push(mibEntry)
          }, [])
        },
        () => {
          query.mibEntry.off()
        }
      )

      query.product.on(
        'value',
        (sn) => {
          this.$refs.spinner.hide()
          this.pageLoaded = true
          this.product = _.transform(sn.val(), (result, value, key) => {
            result.push({
              '.key': key,
              ...value
            })
          }, [])
        },
        () => {
          query.product.off()
        }
      )
    },
  },
  watch: {
    logFilter: {
      deep: true,
      handler: function (nv) {
        this.currPage = 1
        this.currPaginationSec = 1
      }
    },
    'logFilter.category.value': function (nv, ov) {
      if (nv !== ov) {
        this.logFilter.family.value = 'any'
      }
    }
    // 'user.custom' (curr, prev) {
    //   if (curr != null) {
    //     this.getData(curr)
    //   }
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../scss/_varaibles.scss';
@import '../../scss/_mixin.scss';

.main_table{
  padding-bottom: 70px;
}

.upload_modal .form_label, .total, .function_bar .upload{
  text-align: right;
}
.function_bar {
  .upload{
    font-size: 20px;
  }
  .form-group{
    float: left;
  }
}
.form_label{
  padding: 5px 15px;
  white-space: nowrap;
}
.control_label{
  padding-right: 5px;
}

.upload_modal{
  .download{
    margin-left: -9px;
    margin-right: 9px;
  }
  .form-group{
    margin-bottom: 3px;
  }
  .form-group.larger_form_group{
    margin-bottom: 7px;
  }
}
.action_buttons{

}
.log_table{
  td {
    padding: 15px;
  }
  .media-top{
    display: flex;
    align-items: flex-start;
    .media-top__info {
      flex: 1 1 auto;
      min-width: 0;
      .version-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
      }
      .time {
        display: block;
        margin-top: -4px;
        margin-bottom: 4px;
      }
    }
    .action_buttons {
      flex-shrink: 0;
      padding: 4px 0;
    }
  }
  .version{
    display: inline-block;
    // width: 130px;
    padding:3px 7px 3px 0px;
    font-size: 20px;
  }
  .time{
    color: #d7d7d7;
    padding-right:5px;
    .glyphicon{
      font-size: 10px;
      cursor: default;
      padding-right:5px;
    }
    span{
      font-size: 12px;
    }
  }
  span.download{
    cursor:pointer;
    span{
      font-size: 14px;
    }
  }
}
textarea{
  min-height: 200px;
  resize: vertical;
}
.warning{
  padding: 3px 5px;
  color: #fff;
  background-color: #f00;
}
.single_log{
  position: relative;
  overflow: hidden;
}
.badge_group{
  padding-right: 40px;
}
.customized__badge{
  &.develop{
    @include genRightCornerBadge(50px, 18px, 14px, $warning, #000);
    right:-50px;
  }
  &.release{
    @include genRightCornerBadge(50px, 18px, 14px, $success, #fff);
    right:-50px;
  }
}
.error{
  border:2px solid #e33;
}
.err_msg{
  padding-right: 7px;
  padding-left: 7px;
  & span{
    display: inline-block;
    white-space: nowrap;
    line-height: 30px;
    font-size: 12px;
    width:100%;
    height:30px;
    background-color: #e33;
    color: #fff;
    padding: 0px 7px;
  }
}
.largerTotalLength {
  font-size: 18px;
  font-weight: bolder;
  padding-top: 3px;
  padding-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// Private_MIB_V2.vue?1c75abac